<template>
  <el-dialog v-loading="isSaving" :center="center" :close-on-click-modal="closeOnClickModal" :width="dialogWidth" :visible="dialogVisible" top="8vh" :before-close="handleClose"
    @open="onDialogOpen">
    <template #title>
      <span class="el-dialog__title">{{`${model.Id > 0 ? "编辑" : "添加"}家长`}}</span>
    </template>
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form key="form" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :rules="rules" :model="model" label-width="110px">
        <el-form-item label="姓名" prop="Name">
          <el-input placeholder="请输入姓名" v-model="model.Name" maxlength="250" class="input-width" />
        </el-form-item>
        <el-form-item label="手机" prop="Phone">
          <el-input placeholder="请输入手机" v-model="model.Phone" maxlength="20" class="input-width" />
        </el-form-item>
        <el-form-item label="邮箱" prop="Email">
          <el-input placeholder="请输入邮箱" v-model="model.Email" maxlength="250" class="input-width" />
        </el-form-item>
        <el-form-item label="密码" prop="Password">
          <el-scs-password ref="el-scs-password" placeholder="请输入密码" v-model="model.Password" class="input-width" />
        </el-form-item>
        <el-form-item label="确认密码" prop="PasswordAgain">
          <el-scs-password ref="el-scs-passwordagain" placeholder="请输入确认密码" v-model="model.PasswordAgain" class="input-width" />
        </el-form-item>
        <el-form-item v-if="!isAdd" label="启用状态">
          <el-select v-model="model.Enable" placeholder="请选择启用状态">
            <el-option key="0" label="启用" :value="true"></el-option>
            <el-option key="1" label="停用" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联学生">
          <el-select placeholder="请选择关联学生" filterable remote :remote-method="handleRelatedStudentRemote" v-model="model.RelatedStudentId"
            :loading="studentLoading" @blur="onRelatedStudentBlur">
            <el-option v-for="(item) in studentList" :key="item.StudentId" :value="item.StudentId" :label="item.Phone" :disabled="item.StudentId === -1" />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <div class="dialog-footer popup-footer">
        <el-row>
          <el-col :span="20" class="footer-left">
            <span v-if="!showError"></span>
            <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
          </el-col>
          <el-col :span="4" class="footer-right">
            <el-button v-if="!readonly" :disabled="isSaving" type="primary" @click="saveChanges">确认保存</el-button>
          </el-col>
        </el-row>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mixinDevice } from "@/core/mixin";
import { getStudyAbroadStudentList } from "@/service/studyAbroad.service";
import { saveParent } from "@/service/parent.service";

const defaultData = {
  Id: 0,
  Enable: true,
  Name: null,
  Phone: null,
  Email: null,
  Password: null,
  PasswordAgain: null,
  Students: [],
  RelatedStudentId: null,
};

const mixin_generalMethods = {
  methods: {
    validate() {
      let isValid = true;

      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.validate((valid) => {
          isValid = valid;
        });
      }

      return isValid;
    },
  },
};

export default {
  name: "parentAccountEditor",
  mixins: [mixinDevice, mixin_generalMethods],
  components: {
    elScsPassword: () => import("../common/el-scs-password"),
  },
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "700px",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return Object.clone(defaultData);
      },
    },
    isTimeQuantity: {
      type: Boolean,
      default: false,
    },
    serviceHoursAvailable: {
      type: Number,
      default: 0,
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    const _validatePhone = (rule, value, callback) => {
      let message = "";
      if (!!value) {
        // if (value.length != 11 && value.length != 10) {
        //   message = "请输入10位或11位数手机号";
        // }
      } else {
        message = "请输入手机";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    const _validateEmail = (rule, value, callback) => {
      let message = "";
      if (!!value) {
        // TODO
      } else {
        message = "请输入邮箱";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    const _validatePass = (rule, value, callback) => {
      if (value) {
        let isValid = value.match(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
        );
        if (!isValid) {
          callback(new Error("密码需为8位长度的大小写字母和数字"));
        } else {
          callback();
        }
      } else {
        callback();
        //callback(new Error("请输入密码"));
      }
    };

    const _validatePassCheck = (rule, value, callback) => {
      // if (typeof value === "undefined" || value === "") {
      //   callback(new Error("请输入确认密码"));
      // } else
      if (!!this.model.password && value !== this.model.password) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };

    const _self = this;
    return {
      dialogVisible: false,
      showError: false,
      errorMessage: "",
      rules: {
        Name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
          {
            min: 0,
            max: 20,
            message: "最大长度在为20个字符",
            trigger: "blur",
          },
        ],
        Phone: [
          {
            required: true,
            message: "请输入手机",
            trigger: "blur",
          },
          {
            validator: _validatePhone,
            trigger: "blur",
          },
        ],
        Email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
          },
          {
            validator: _validateEmail,
            trigger: "blur",
          },
        ],
        Password: [
          {
            required: false,
            validator: _validatePass,
            trigger: "blur",
          },
        ],
        PasswordAgain: [
          {
            required: false,
            validator: _validatePassCheck,
            trigger: "blur",
          },
        ],
      },
      model: Object.clone(defaultData),
      universityList: [],
      studentLoading: false,
      studentList: [],
      prevStudentList: null,
      isSaving: false
    };
  },
  created() {
    this.reloadVisible();
  },
  computed: {
    dialogWidth() {
      return !this.isMobile() ? this.width : "100%";
    },
    isAdd() {
      return !this.model.Id;
    },
  },
  methods: {
    // 与服务端交互数据相关方法
    async loadStudentListFromServer(keyWord = null) {
      this.studentLoading = true;
      try {
        let result = await getStudyAbroadStudentList({
          pageNumber: 1,
          pageSize: 10,
          keyWord,
          additionalFilter:{
            getAll: true,
            viewFullPhone: true
          }
        });
        if (!!result && result.success) {
          this.studentList = result.data.Results;
          if (result.data.RecordCount > result.data.Results.length) {
            this.studentList.push({
              StudentId: -1,
              Phone: "更多(请输入关键词查询)",
            });
          }
        } else {
          this.studentList = [];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.studentLoading = false;
        this._rsRemoteTimer = null;
      }
    },
    async saveParentToServer() {
      try {
        this.isSaving = true;
        let saveData = Object.clone(this.model);
        saveData.StudentIds = [];
        if (!!this.model.RelatedStudentId) {
          saveData.StudentIds.push(this.model.RelatedStudentId);
        }

        let result = await saveParent(saveData);
        if (!result.success) {
          this.errorMessage = result.message;
          this.showError = true;
        } else {
          this.$message.success("保存成功");
          this.showError = false;
          this.$emit("saveSuccess", {isAdd: this.isAdd, phone: this.model.Phone});
          this.closeDialog();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isSaving = false;
      }
    },

    reloadModelFromDataIn() {
      if (!this.dialogVisible) return;

      this.showError = false;
      let model = Object.clone(this.data || defaultData);
      let student = model.Students.length > 0 ? model.Students[0] : null;
      model.RelatedStudentId = !!student ? student.Id : null;
      this.model = model;
      let keyWord = !!student ? student.Phone : null;
      this.loadStudentListFromServer(keyWord);

      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.resetFields();
      }
    },
    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible !== newValue) {
        this.dialogVisible = newValue;
      }
    },
    showDialog() {
      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    saveChanges() {
      this.saveParentToServer();
    },
    handleClose(done) {
      this.closeDialog();
    },
    onDialogOpen() {
      this.reloadModelFromDataIn();
    },
    handleRelatedStudentRemote(keyWord) {
      this.prevStudentList = this.studentList;
      if (!!this._rsRemoteTimer) {
        clearTimeout(this._rsRemoteTimer);
      }
      this._rsRemoteTimer = setTimeout(() => {
        this.loadStudentListFromServer(keyWord);
      }, 200);
    },
    onRelatedStudentBlur() {
      setTimeout(() => {
        if (
          !this.studentList.some(
            (item) => item.StudentId === this.model.RelatedStudentId
          ) &&
          !!this.prevStudentList
        ) {
          this.studentList = this.prevStudentList;
        }
        this.prevStudentList = null;
      }, 200);
    },
  },
  watch: {
    visible(newValue) {
      this.reloadVisible();
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-footer {
  margin-top: 0;
}

.popup-content-area-small {
  min-height: 400px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/parentAccount/parentAccountEditor.vue